import { createBrowserRouter, redirect } from 'react-router';
// Route map reference: docs/design/WORK_ITEM_LINKING_DESIGN.md §6
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import TaskBoard from './pages/TaskBoard';
import SprintManagement from './pages/SprintManagement';
import SprintBoard from './pages/SprintBoard';
import PlanningBoard from './pages/PlanningBoard';
import SpreadsheetView from './pages/SpreadsheetView';
import CostsSpreadsheetPage from './pages/CostsSpreadsheetPage';
import BugTracker from './pages/BugTracker';
import Reports from './pages/Reports';
import Retrospectives from './pages/Retrospectives';
import NotFound from './pages/NotFound';
import Settings from './pages/Settings';
import QuarterlyProjects from './pages/QuarterlyProjects';
import TaskNotificationsDemo from './pages/TaskNotificationsDemo';
import PlanningPoker from './pages/PlanningPoker';
import GanttChart from './pages/GanttChart';
import Calendar from './pages/Calendar';
import ProjectCalendarPage from './pages/ProjectCalendarPage';
import ProjectMeetingsPage from './pages/ProjectMeetingsPage';
import ProjectChangeLogs from './pages/ProjectChangeLogs';
import ProjectAccounting from './pages/ProjectAccounting';
import SprintPlanningBoard from './pages/SprintPlanningBoard';
import ProjectSettings from './pages/ProjectSettings';
import EpicsView from './pages/EpicsView';
import AllowedUsers from './pages/AllowedUsers';
import Requirements from './pages/Requirements';
import StandupPage from './pages/StandupPage';
import OrgNewsFeed from './pages/OrgNewsFeed';
import ProjectNewsFeed from './pages/ProjectNewsFeed';
import DeveloperTimesheet from './pages/DeveloperTimesheet';
import StakeholderReports from './pages/StakeholderReports';
import TaskAssignment from './pages/TaskAssignment';
import TaskDetail from './pages/TaskDetail';
import UserProfile from './pages/UserProfile';

// Protected wrapper components
import ProtectedRootLayout from './components/ProtectedRootLayout';
import ProtectedProjectLayout from './components/ProtectedProjectLayout';
import ProtectedUserDashboard from './pages/ProtectedUserDashboard';
import ProtectedStakeholderDashboard from './pages/ProtectedStakeholderDashboard';
import ProtectedMilestoneDetail from './pages/ProtectedMilestoneDetail';
import ProtectedTaskDetail from './pages/ProtectedTaskDetail';
import ProtectedProjectLanding from './pages/ProtectedProjectLanding';
import ProtectedStakeholderLanding from './pages/ProtectedStakeholderLanding';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: Landing,
    ErrorBoundary: NotFound,
  },
  {
    path: '/login',
    Component: Login,
    ErrorBoundary: NotFound,
  },
  {
    path: '/project',
    Component: ProtectedProjectLanding,
    ErrorBoundary: NotFound,
  },
  {
    path: '/stakeholder/:type',
    Component: ProtectedStakeholderLanding,
    ErrorBoundary: NotFound,
  },
  {
    path: '/app',
    Component: ProtectedRootLayout,
    ErrorBoundary: NotFound,
    children: [
      { index: true, Component: Dashboard },
      { path: 'dashboard', Component: ProtectedUserDashboard },
      { path: 'projects', Component: Projects },
      { path: 'quarterly', Component: QuarterlyProjects },
      { path: 'notifications', Component: TaskNotificationsDemo },
      { path: 'planning-poker', Component: PlanningPoker },
      { path: 'bugs', Component: BugTracker },
      { path: 'reports', Component: Reports },
      { path: 'retrospectives', Component: Retrospectives },
      { path: 'settings', Component: Settings },
      { path: 'profile', Component: UserProfile },
      { path: 'settings/profile', loader: () => redirect('/app/profile') },
      { path: 'users/:userId', Component: UserProfile },
      { path: 'gantt-chart', Component: GanttChart },
      { path: 'calendar', Component: Calendar },
      { path: 'allowed-users', Component: AllowedUsers },
      { path: 'newsfeed', Component: OrgNewsFeed },
      { path: 'assign', Component: TaskAssignment },
      { path: 'timesheet', Component: DeveloperTimesheet },
      { path: 'team-reports', Component: StakeholderReports },
    ],
  },
  {
    path: '/app/projects/:projectId',
    Component: ProtectedProjectLayout,
    ErrorBoundary: NotFound,
    children: [
      { index: true, Component: ProjectDetails },
      { path: 'tasks', Component: TaskBoard },
      { path: 'task/:taskId', Component: TaskDetail },
      { path: 'epics', Component: EpicsView },
      { path: 'planning', Component: PlanningBoard },
      { path: 'spreadsheet', Component: SpreadsheetView },
      { path: 'costs', Component: CostsSpreadsheetPage },
      { path: 'gantt', Component: GanttChart },
      { path: 'sprints', Component: SprintManagement },
      { path: 'sprints/:sprintId', Component: SprintBoard },
      { path: 'sprint-planning', Component: SprintPlanningBoard },
      { path: 'changelogs', Component: ProjectChangeLogs },
      { path: 'settings', Component: ProjectSettings },
      { path: 'requirements', Component: Requirements },
      { path: 'standup', Component: StandupPage },
      { path: 'newsfeed', Component: ProjectNewsFeed },
      { path: 'calendar', Component: ProjectCalendarPage },
      { path: 'meetings', Component: ProjectMeetingsPage },
      { path: 'accounting', Component: ProjectAccounting },
    ],
  },
  {
    path: '/dashboard',
    loader: () => redirect('/app/dashboard'),
    ErrorBoundary: NotFound,
  },
  {
    path: '/assign',
    loader: () => redirect('/app/assign'),
    ErrorBoundary: NotFound,
  },
  {
    path: '/timesheet',
    loader: () => redirect('/app/timesheet'),
    ErrorBoundary: NotFound,
  },
  {
    path: '/team-reports',
    loader: () => redirect('/app/team-reports'),
    ErrorBoundary: NotFound,
  },
  {
    path: '/stakeholder',
    Component: ProtectedStakeholderDashboard,
    ErrorBoundary: NotFound,
  },
  {
    path: '/milestone/:milestoneId',
    Component: ProtectedMilestoneDetail,
    ErrorBoundary: NotFound,
  },
  {
    path: '/task/:taskId',
    Component: ProtectedTaskDetail,
    ErrorBoundary: NotFound,
  },
  {
    path: '*',
    Component: NotFound,
  },
]);